import { InfoCircleFilled, QuestionCircleFilled } from "@ant-design/icons";
import { Card, Row, Space, Tooltip } from "antd";
import { ReactNode } from "react";

interface IIconTooltipProps {
  children: ReactNode;
  placement?: "top" | "left" | "right" | "bottom" | "bottomRight";
  iconType?: "info" | "question";
  iconColor?: "default" | "info" | "question";
  textAlign?:
    | "start"
    | "end"
    | "left"
    | "right"
    | "center"
    | "justify"
    | "match-parent";
  isShowCard?: boolean;
  padding?: string;
  innerWidth?: string;
  prevText?: string;
  nextText?: string;
}
const IconColorMapper: Record<string, string> = {
  default: "#1a1a1a",
  info: "#0049b0",
  question: "#b5bbc2",
};
const IconTooltip = ({
  children,
  placement = "top",
  iconType = "info",
  iconColor = "default",
  textAlign = "center",
  innerWidth = "100%",
  isShowCard = true,
  padding = "5px",
  prevText,
  nextText,
}: IIconTooltipProps) => {
  return (
    <Space style={{ zIndex: 9999 }}>
      {prevText && <p>{prevText}</p>}
      <Tooltip
        overlayInnerStyle={{
          width: innerWidth,
          padding,
          zIndex: 9999,
          textAlign,
        }}
        placement={placement}
        title={
          <>
            {isShowCard ? (
              <Card
                style={{ padding: 0, margin: 0, borderRadius: 2, zIndex: 9999 }}
                bodyStyle={{ zIndex: 99999, textAlign: "center" }}
                size="small"
              >
                {children}
              </Card>
            ) : (
              <span>{children}</span>
            )}
          </>
        }
      >
        {iconType === "info" && (
          <InfoCircleFilled
            rev={""}
            style={{ color: IconColorMapper[iconColor], cursor: "default" }}
          />
        )}
        {iconType === "question" && (
          <QuestionCircleFilled
            rev={""}
            style={{
              color: IconColorMapper[iconColor],
              cursor: "default",
            }}
          />
        )}
      </Tooltip>
      {nextText && <p style={{ fontSize: "12px" }}>{nextText}</p>}
    </Space>
  );
};

export default IconTooltip;
